export class DictionaryElement
{
	constructor(defaultText: string)
	{
		this.DefaultText = defaultText;
		this.Cultures = {};
	}

	public DefaultText: string;

	public AddCultureText(cultureCode: string, text: string): any
	{
		this.Cultures[cultureCode] = text;
		return this; // This allows us to string this method during the creation of this instance

		/* Don't delete "return this;", it's what allows the cultureDictionary to use [...].AddCultureText(...).AddCultureText(...).AddCultureText(...) etc. */
	}

	public GetCultureText(languageCode: string, cultureCode: string): string
	{
		// IMPORTANT: If there is no culture code, e.g. es-MX, then you need to return the default text
		// Otherwise you can return the text based on the culture code

		if (this.Cultures[cultureCode] !== undefined)
		{
			return this.Cultures[cultureCode];
		}
		else if (this.Cultures[languageCode] !== undefined)
		{
			return this.Cultures[languageCode];
		}
		else
		{
			return this.DefaultText;
		}
	}

	private Cultures: any;
}

export class TextResourceClass
{
	constructor()
	{
		this.BuildLibrary();
	}

	private culture: any = null;
	private cultureDictionary: object = {};

	// Set your languages here, please. Also make the string all LOWER case.
	private langES = "es-mx";

	private AddTextKey(textKey: string, defaultText: string): DictionaryElement
	{
		if (this.cultureDictionary[textKey] !== null)
		{
			this.cultureDictionary[textKey] = new DictionaryElement(defaultText);
		}
		else
		{
			// throw an error
		}

		return this.cultureDictionary[textKey];
	}

	private BuildLibrary(): void
	{
		// Naming convention for dictionary items: (Feature||Page)_(FeatureName||PageName)_Descriptor
		// Single word naming convention: (Word)_Descriptor
		this.cultureDictionary = {};

		// Single Words
		this.cultureDictionary["Word_All"] = new DictionaryElement("All")
			.AddCultureText(this.langES, "Todas");
		this.cultureDictionary["Word_And"] = new DictionaryElement("and")
			.AddCultureText(this.langES, "y");
		this.cultureDictionary["Word_Done"] = new DictionaryElement("Done")
			.AddCultureText(this.langES, "Listo");
		this.cultureDictionary["Word_Regular"] = new DictionaryElement("Regular")
			.AddCultureText(this.langES, "Regular");
		this.cultureDictionary["Word_Back"] = new DictionaryElement("Back")
			.AddCultureText(this.langES, "Atrás");
		this.cultureDictionary["Word_Greeting"] = new DictionaryElement("Hello")
			.AddCultureText(this.langES, "Hola");
		this.cultureDictionary["Word_Hours"] = new DictionaryElement("hours")
			.AddCultureText(this.langES, "horas");
		this.cultureDictionary["Word_ThankYou"] = new DictionaryElement("Thank you")
			.AddCultureText(this.langES, "Gracias");
		this.cultureDictionary["Word_Minutes"] = new DictionaryElement("minutes")
			.AddCultureText(this.langES, "minutos");
		this.cultureDictionary["Word_Seconds"] = new DictionaryElement("seconds")
			.AddCultureText(this.langES, "segundos");
		this.cultureDictionary["Word_Continue"] = new DictionaryElement("Continue")
			.AddCultureText(this.langES, "Continuar");
		this.cultureDictionary["Word_Yes"] = new DictionaryElement("Yes")
			.AddCultureText(this.langES, "Sí");
		this.cultureDictionary["Word_No"] = new DictionaryElement("No")
			.AddCultureText(this.langES, "No");
		this.cultureDictionary["Word_Womens"] = new DictionaryElement("Womens")
			.AddCultureText(this.langES, "Mujeres");
		this.cultureDictionary["Word_Mens"] = new DictionaryElement("Mens")
			.AddCultureText(this.langES, "Hombres");
		this.cultureDictionary["Word_Girls"] = new DictionaryElement("Girls")
			.AddCultureText(this.langES, "Niñas");
		this.cultureDictionary["Word_Boys"] = new DictionaryElement("Boys")
			.AddCultureText(this.langES, "Niños");
		this.cultureDictionary["Word_Infant"] = new DictionaryElement("Infant")
			.AddCultureText(this.langES, "Infantil");
		this.cultureDictionary["Word_Kids"] = new DictionaryElement("Kids")
			.AddCultureText(this.langES, "Niños");
		this.cultureDictionary["Word_Teen"] = new DictionaryElement("Teen")
			.AddCultureText(this.langES, "Adolescente");
		this.cultureDictionary["Word_Toddler"] = new DictionaryElement("Toddler")
			.AddCultureText(this.langES, "Niñito");
		this.cultureDictionary["Word_Star"] = new DictionaryElement("Star")
			.AddCultureText(this.langES, "Estrella");
		this.cultureDictionary["Word_Stars"] = new DictionaryElement("Stars")
			.AddCultureText(this.langES, "Estrellas");
		this.cultureDictionary["Word_Update"] = new DictionaryElement("Update")
			.AddCultureText(this.langES, "Actualizar");
		this.cultureDictionary["Word_Close"] = new DictionaryElement("Close")
			.AddCultureText(this.langES, "Cerrar");
		this.cultureDictionary["Word_Warning"] = new DictionaryElement("Warning")
			.AddCultureText(this.langES, "Advertencia");
		this.cultureDictionary["Word_Size"] = new DictionaryElement("Size")
			.AddCultureText(this.langES, "Talla");
		this.cultureDictionary["Word_Quantity"] = new DictionaryElement("Quantity")
			.AddCultureText(this.langES, "Cantidad");
		this.cultureDictionary["Word_Loading"] = new DictionaryElement("Loading").AddCultureText(this.langES, "Cargando");

		// Shorter and more common phrases
		this.cultureDictionary["Phrase_ReadMore"] = new DictionaryElement("Read More")
			.AddCultureText(this.langES, "Ver Más");
		this.cultureDictionary["Phrase_ReadLess"] = new DictionaryElement("Read Less")
			.AddCultureText(this.langES, "Ver Menos");
		this.cultureDictionary["Phrase_Less"] = new DictionaryElement("Less")
			.AddCultureText(this.langES, "Menos");
		this.cultureDictionary["Phrase_More"] = new DictionaryElement("More")
			.AddCultureText(this.langES, "Más");
		this.cultureDictionary["Phrase_ViewAll"] = new DictionaryElement("View All")
			.AddCultureText(this.langES, "Ver Todo");
		this.cultureDictionary["Phrase_PlusSize"] = new DictionaryElement("Plus Size")
			.AddCultureText(this.langES, "Talla Extra");
		this.cultureDictionary["Phrase_MessageSent"] = new DictionaryElement("Message Sent")
			.AddCultureText(this.langES, "Mensaje Enviado");
		this.cultureDictionary["Phrase_OutOfFiveStars"] = new DictionaryElement("Out Of 5 Stars")
			.AddCultureText(this.langES, "De 5 Estrellas");

		// Feature_Account
		this.cultureDictionary["Feature_Account_EmailError"] = new DictionaryElement("Please specify a valid email.")
			.AddCultureText(this.langES, "Por favor, especifique un correo electrónico válido.");
		this.cultureDictionary["Feature_Account_PasswordError"] = new DictionaryElement("A strong password is at least 6 characters long, has a number, a lowercase letter, an uppercase letter, and a special character.")
			.AddCultureText(this.langES, "Una contraseña segura tiene al menos 6 caracteres, tiene un número, una letra minúscula, una letra mayúscula y un carácter especial.");

		// Feature_Banner
		this.cultureDictionary["Feature_Banner_PricesLowAs"] = new DictionaryElement("(Prices As Low As)")
			.AddCultureText(this.langES, "(Precios Tan Bajos Como)");

		// Feature_Chat
		this.cultureDictionary["Feature_Chat_AgentsUnavailable"] = new DictionaryElement("Agents Are Unavailable").AddCultureText(this.langES, "Los agentes no están disponibles");
		this.cultureDictionary["Feature_Chat_AllAgentsBusy"] = new DictionaryElement("All Agents Are Busy").AddCultureText(this.langES, "Todos Los Agentes Están Ocupados");
		this.cultureDictionary["Feature_Chat_AskAnything"] = new DictionaryElement("Ask us anything!").AddCultureText(this.langES, "¡Pregúntenos Cualquier Cosa!");
		this.cultureDictionary["Feature_Chat_AskAnythingFancy"] = new DictionaryElement("Ask us anything fancy!").AddCultureText(this.langES, "¡Pregúntanos algo elegante!");
		this.cultureDictionary["Feature_Chat_AskAnythingFunny"] = new DictionaryElement("Ask us anything funny!").AddCultureText(this.langES, "¡Pregúntanos algo gracioso!");
		this.cultureDictionary["Feature_Chat_AskAnythingSpooky"] = new DictionaryElement("Ask us anything spooky!").AddCultureText(this.langES, "¡Pregúntanos algo espeluznante!");
		this.cultureDictionary["Feature_Chat_ContactUs"] = new DictionaryElement("Contact Us").AddCultureText(this.langES, "Contáctenos");
		this.cultureDictionary["Feature_Chat_CustomerSupport"] = new DictionaryElement("Customer Support").AddCultureText(this.langES, "Atención al Cliente");
		this.cultureDictionary["Feature_Chat_LiveChat"] = new DictionaryElement("Live Chat").AddCultureText(this.langES, "Chat en Vivo");

		// Feature_Checkout
		this.cultureDictionary["Feature_Checkout_Prop65_1"] = new DictionaryElement("This product can expose you to chemicals, which are known to the State of California to cause cancer.").AddCultureText(this.langES, "Este producto puede exponerse a sustancias químicas, que el estado de California sabe que causan cáncer.");
		this.cultureDictionary["Feature_Checkout_Prop65_2"] = new DictionaryElement("This product can expose you to chemicals, which are known to the State of California to cause birth defects or other reproductive harm.").AddCultureText(this.langES, "Este producto puede exponerse a sustancias químicas, que el Estado de California sabe que causan defectos de nacimiento u otros daños reproductivos.");
		this.cultureDictionary["Feature_Checkout_Prop65_3"] = new DictionaryElement("This product can expose you to chemicals, which are known to the State of California to cause cancer and birth defects or other reproductive harm.").AddCultureText(this.langES, "Este producto puede exponerlo a sustancias químicas que, según el estado de California, causan cáncer y defectos de nacimiento u otros daños reproductivos");
		this.cultureDictionary["Feature_Checkout_Prop65_Website"] = new DictionaryElement(" For more information go to <a href=\"https:// www.p65warnings.ca.gov/\" target=\"_blank\">www.p65warnings.ca.gov</a>.").AddCultureText(this.langES, " Para más información vaya a <a href=\"https:// www.p65warnings.ca.gov/\" target=\"_blank\">www.p65warnings.ca.gov</a>.");
		this.cultureDictionary["Feature_Checkout_StepCount1"] = new DictionaryElement("Step 1 of 4").AddCultureText(this.langES, "Paso 1 de 4");
		this.cultureDictionary["Feature_Checkout_StepCount2"] = new DictionaryElement("Step 2 of 4").AddCultureText(this.langES, "Paso 2 de 4");
		this.cultureDictionary["Feature_Checkout_StepCount3"] = new DictionaryElement("Step 3 of 4").AddCultureText(this.langES, "Paso 3 de 4");
		this.cultureDictionary["Feature_Checkout_StepCount4"] = new DictionaryElement("Step 4 of 4").AddCultureText(this.langES, "Paso 4 de 4");

		// Feature_Client
		this.cultureDictionary["Feature_Client_ItemQty"] = new DictionaryElement("You have |*| item|*| in your shopping cart.")
			.AddCultureText(this.langES, "Tienes |*| artículo|*|  en tu carrito de compras.");
		this.cultureDictionary["Feature_Client_PreOrderItemQty"] = new DictionaryElement("You have |*| item|*| in your pre-order cart.")
			.AddCultureText(this.langES, "Tienes |*| artículo|*|  en tu pre-pedido carrito de compras.");

		// Data Privacy Policy
		this.cultureDictionary["Client_CookieModal_Header"] = new DictionaryElement("Your Cookie Settings")
			.AddCultureText(this.langES, "TU CONFIGURACIÓN DE COOKIES");
		this.cultureDictionary["Client_CookieModal_Sentence"] = new DictionaryElement("would like you to accept cookies for the purpose of performance, social media, and advertising. By continuing to use our site you are agreeing to this. For more information see our ")
			.AddCultureText(this.langES, "le gustaría que aceptaras cookies con el propósito de rendimiento, redes sociales y publicidad. Al continuar usando nuestro sitio web, otorgas tu consentimiento para esto. Para obtener más información, consulta nuestra ");
		this.cultureDictionary["Client_CookieModal_AceeptContinue"] = new DictionaryElement("Accept & Continue")
			.AddCultureText(this.langES, "Aceptar y Continuar");
		this.cultureDictionary["Client_CookieModal_CookieSettings"] = new DictionaryElement("Cookie Settings")
			.AddCultureText(this.langES, "Configuración de Cookies");
		this.cultureDictionary["Client_CookieModal_PrivacyCookiesText"] = new DictionaryElement("Privacy & Cookie Policy")
			.AddCultureText(this.langES, "Política de privacidad y cookies");

		// Feature_Coupon
		this.cultureDictionary["Feature_Coupon_Logo_AltText"] = new DictionaryElement("{0} Logo")
			.AddCultureText(this.langES, "Logotipo De {0}");
		this.cultureDictionary["Feature_Coupon_Invalid_Headline"] = new DictionaryElement("Sorry!")
			.AddCultureText(this.langES, "¡Lo siento!");
		this.cultureDictionary["Feature_Coupon_Invalid_Subtitle"] = new DictionaryElement("Your coupon has expired or is not valid")
			.AddCultureText(this.langES, "Tu cupón ha caducado o no es válido");
		this.cultureDictionary["Feature_Coupon_Monster_AltText"] = new DictionaryElement("The {0} monster mascot peeking its head out.")
			.AddCultureText(this.langES, "La mascota del monstruo de {0} asoma la cabeza.");
		this.cultureDictionary["Feature_Coupon_Success_Headline"] = new DictionaryElement("Lucky You!")
			.AddCultureText(this.langES, "¡Eres Afortunado!");
		this.cultureDictionary["Feature_Coupon_Success_Subtitle"] = new DictionaryElement("Enjoy this special coupon. It's already applied to your cart!")
			.AddCultureText(this.langES, "Disfruta de este cupón especial. ¡Ya está aplicado a tu carrito!");
		this.cultureDictionary["Feature_Coupon_Details"] = new DictionaryElement("See Details")
			.AddCultureText(this.langES, "Ver Detalles");
		this.cultureDictionary["Feature_Coupon_Apply_Error"] = new DictionaryElement("There was a problem applying your coupon. Please reload the page and try again. If this issue persists, please contact customer service.")
			.AddCultureText(this.langES, "Hubo un problema al aplicar tu cupón. Vuelva a cargar la página e inténtelo de nuevo. Si este problema persiste, comuníquese con el servicio de atención al cliente.");

		// Feature_Email_Acquisition_Modal
		this.cultureDictionary["Feature_Email_Acquisition_Modal_Enter_Email"] = new DictionaryElement("Enter email address")
			.AddCultureText("es-MX", "Ingrese correo electrónico");
		this.cultureDictionary["Feature_Email_Acquisition_Modal_Privacy"] = new DictionaryElement("Read our Privacy Policy")
			.AddCultureText(this.langES, "Lea nuestra Política de Privacidad");
		this.cultureDictionary["Feature_Email_Acquisition_Modal_Submit"] = new DictionaryElement("Sign Up!")
			.AddCultureText("es-MX", "¡Regístrate!");
		this.cultureDictionary["Feature_Email_Acqusistion_Modal_Text"] = new DictionaryElement("Join our Costume Club|*|& Receive|*|off|*|Your First Order|*| + updates on exclusive promotions!")
			.AddCultureText(this.langES, "Únete a nuestro Club de Disfraces|*|Y Receibe|*|rebajado|*|en tu primer pedido|*|! Y actualizaciones sobre promociones exclusivas!");
		this.cultureDictionary["Feature_Email_Acquisition_Modal_Thanks"] = new DictionaryElement("Thanks for signing up!")
			.AddCultureText("es-MX", "¡Gracias por registrarte!");

		// / <summary>Group selector section.</summary>
		this.cultureDictionary["GroupSelector_SizeFilter_Text"] = new DictionaryElement("Size Filter")
			.AddCultureText(this.langES, "Filtro Talla");
		this.cultureDictionary["GroupSelector_SelectSize_Text"] = new DictionaryElement("Select Size")
			.AddCultureText(this.langES, "Selecciona Talla");

		// Feature_Header
		this.cultureDictionary["Feature_Header_AccountButton"] = new DictionaryElement("Sign In or Sign Up")
			.AddCultureText(this.langES, "Inicia Sesión o Registrarse");

		// Feature_OrderTracking
		this.cultureDictionary["Feature_OrderTracking_AddError"] = new DictionaryElement("There were some problems trying to add the products from this scene to the cart:")
			.AddCultureText(this.langES, "Hubo algunos problemas al intentar agregar los productos de esta escena al carrito:");
		this.cultureDictionary["Feature_OrderTracking_ConfirmAdd"] = new DictionaryElement("Do you want to add the items that are available to your cart?")
			.AddCultureText(this.langES, "¿Desea agregar los artículos que están disponibles para su carrito?");

		// Feature_ProductReview
		this.cultureDictionary["Feature_ProductReview_RateIt"] = new DictionaryElement("Rate It")
			.AddCultureText(this.langES, "Puntúalo");
		this.cultureDictionary["Feature_ProductReview_HateIt"] = new DictionaryElement("I Hate It")
			.AddCultureText(this.langES, "Lo odio");
		this.cultureDictionary["Feature_ProductReview_DontLikeIt"] = new DictionaryElement("I Don't Like It")
			.AddCultureText(this.langES, "No me gusta");
		this.cultureDictionary["Feature_ProductReview_ItsOkay"] = new DictionaryElement("It's Okay")
			.AddCultureText(this.langES, "Esta bien");
		this.cultureDictionary["Feature_ProductReview_LikeIt"] = new DictionaryElement("I Like It")
			.AddCultureText(this.langES, "Me gusta");
		this.cultureDictionary["Feature_ProductReview_LoveIt"] = new DictionaryElement("I Love It")
			.AddCultureText(this.langES, "Lo amo");
		this.cultureDictionary["Feature_ProductReview_RatingRequired"] = new DictionaryElement("Rating Is Required")
			.AddCultureText(this.langES, "Se requiere calificación");
		this.cultureDictionary["Feature_ProductReview_Clear"] = new DictionaryElement("Clear")
			.AddCultureText(this.langES, "Claro");
		this.cultureDictionary["Feature_ProductReview_Select"] = new DictionaryElement("Please select your rating.")
			.AddCultureText(this.langES, "Por favor seleccione su calificación.");
		this.cultureDictionary["Feature_ProductReview_Title"] = new DictionaryElement("Please enter your title.")
			.AddCultureText(this.langES, "Por favor introduzca su titulo.");
		this.cultureDictionary["Feature_ProductReview_Review"] = new DictionaryElement("Please enter your review.")
			.AddCultureText(this.langES, "Por favor ingrese su comentario.");
		this.cultureDictionary['Feature_ProductReview_ReviewOrUploadRequired'] = new DictionaryElement('A review comment or a photo upload is required.')
			.AddCultureText(this.langES, 'Se requiere un comentario de revisión o una carga de fotos.');
		this.cultureDictionary["Feature_ProductReview_Corrections"] = new DictionaryElement("Please correct the following errors:")
			.AddCultureText(this.langES, "Por favor corrige los siguientes errores:");
		this.cultureDictionary["Feature_ProductReview_Error"] = new DictionaryElement("Something went wrong:")
			.AddCultureText(this.langES, "Algo salió mal:");
		this.cultureDictionary["Feature_ProductReview_Delete"] = new DictionaryElement("Are you sure you want to delete your review?")
			.AddCultureText(this.langES, "¿Estás seguro de que quieres borrar tu reseña?");
		this.cultureDictionary["Feature_ProductReview_Posted"] = new DictionaryElement("Rating Posted")
			.AddCultureText(this.langES, "Calificación Publicada");
		this.cultureDictionary['Feature_ProductReview_ReviewOrUploadRequired'] = new DictionaryElement('Review or upload is required.')
			.AddCultureText(this.langES, 'Se requiere revisar o cargar.');

		// Feature_ProductSelector
		this.cultureDictionary["Feature_ProductSelector_OutofStock"] = new DictionaryElement("Some of the products you selected are out of stock and will not be added to the cart. Continue?")
			.AddCultureText(this.langES, "Algunos de los productos que seleccionó están agotados y no se agregarán al carrito. ¿Continuar?");
		this.cultureDictionary["Feature_CouplesSelector_Header"] = new DictionaryElement("Couples Costume Selector")
			.AddCultureText(this.langES, "Selector de Disfraces de Parejas");
		this.cultureDictionary["Feature_CouplesSelector_Coordinate"] = new DictionaryElement("Coordinate Your Couple")
			.AddCultureText(this.langES, "Coordina tu Pareja");
		this.cultureDictionary["Feature_CouplesSelector_Description"] = new DictionaryElement("Coordinate costumes for you and yours with one convenient tool!")
			.AddCultureText(this.langES, "¡Coordina los trajes para ti y los tuyos con una herramienta práctica!");
		this.cultureDictionary["Feature_GroupsSelector_Header"] = new DictionaryElement("Group Costume Selector")
			.AddCultureText(this.langES, "Selector de Disfraces Grupales");
		this.cultureDictionary["Feature_GroupsSelector_Create"] = new DictionaryElement("Create Your Own Group")
			.AddCultureText(this.langES, "Crea tu Propio Grupo");
		this.cultureDictionary["Feature_GroupsSelector_Description"] = new DictionaryElement("Coordinate costumes for your entire group - large or small - with one convenient tool!")
			.AddCultureText(this.langES, "¡Coordine los disfraces para todo su grupo, grande o pequeño, con una herramienta práctica!");

		// Feature_ProductUpsell
		this.cultureDictionary["Feature_ProductUpsell_SelectSize"] = new DictionaryElement("Please select a size and/or quantity to add to the order.")
			.AddCultureText(this.langES, "Seleccione un tamaño y/o cantidad para agregar al pedido.");

		// Feature_Product_Theme
		this.cultureDictionary["Feature_Theme_SelectSize"] = new DictionaryElement("Please select a size.")
			.AddCultureText(this.langES, "Por favor seleccione una talla.");
		this.cultureDictionary["Feature_Theme_SelectHeightFt"] = new DictionaryElement("Please select your height in feet.")
			.AddCultureText(this.langES, "Por favor seleccione su altura en pies.");
		this.cultureDictionary["Feature_Theme_SelectHeightIn"] = new DictionaryElement("Please select your height in inches.")
			.AddCultureText(this.langES, "Por favor seleccione su altura en pulgadas.");
		this.cultureDictionary["Feature_Theme_NotiErr"] = new DictionaryElement("There was a problem saving the notification, please try again.")
			.AddCultureText(this.langES, "Hubo un problema al guardar la notificación. Inténtalo de nuevo.");
		this.cultureDictionary["Feature_Theme_SgnUpThnkYou"] = new DictionaryElement("Thank you for signing up for our email notification.  You will be notified via email when the product is back in stock.")
			.AddCultureText(this.langES, "Gracias por suscribirse a nuestra notificación por correo electrónico. Se le notificará por correo electrónico cuando el producto vuelva a estar disponible.");
		this.cultureDictionary["Feature_Theme_EmailThankYou"] = new DictionaryElement("Thank you for signing up for our email notification.")
			.AddCultureText(this.langES, "Gracias por suscribirse a nuestra notificación por correo electrónico.");
		this.cultureDictionary["Feature_Theme_AddProdError"] = new DictionaryElement("There were some problems trying to add the products from this scene to the cart")
			.AddCultureText(this.langES, "Hubo algunos problemas al intentar agregar los productos de esta escena al carro");
		this.cultureDictionary["Feature_Theme_ComingSoon"] = new DictionaryElement("Measurements Coming Soon")
			.AddCultureText(this.langES, "Las Medidas Vendrán Pronto");

		// Feature_QuantityStepper
		this.cultureDictionary["Feature_QuantityStepper_DecreaseAltText"] = new DictionaryElement("Decrease quantity by 1. Quantity is {0}.")
				.AddCultureText(this.langES, "Disminuir la cantidad en 1. La cantidad es {0}.");
		this.cultureDictionary["Feature_QuantityStepper_IncreaseAltText"] = new DictionaryElement("Increase quantity by 1. Quantity is {0}.")
				.AddCultureText(this.langES, "Aumentar la cantidad en 1. La cantidad es {0}.");
		this.cultureDictionary["Feature_QuantityStepper_RemoveAltText"] = new DictionaryElement("Remove this item from your cart.")
				.AddCultureText(this.langES, "Elimina este artículo de tu carrito.");
		this.cultureDictionary["Feature_QuantityStepper_UpdateAltText"] = new DictionaryElement("Update this item's quantity in your cart.")
				.AddCultureText(this.langES, "Actualiza la cantidad de este artículo en tu carrito.");

		// Feature_Receipt
		this.cultureDictionary["Feature_Receipt_TaxEstimate"] = new DictionaryElement("Estimated Tax")
			.AddCultureText(this.langES, "Impuesto Estimado");

		// Feature_Recommendations
		this.cultureDictionary["Feature_Recommendations_ComingSoon"] = new DictionaryElement("New & Coming Soon")
			.AddCultureText(this.langES, "Nuevo & Muy Pronto");
		this.cultureDictionary["Feature_Recommendations_Accessories"] = new DictionaryElement("Recommended Accessories")
			.AddCultureText(this.langES, "Accesorios Recomendados");
		this.cultureDictionary['Feature_Recommendations_Decorations'] = new DictionaryElement('Recommended Decorations')
			.AddCultureText(this.langES, 'Decoraciones Recomendadas');
		this.cultureDictionary["Feature_Recommendations_Products"] = new DictionaryElement("Recommended Products")
			.AddCultureText(this.langES, "Productos Recomendados");
		this.cultureDictionary["Feature_Recommendations_MayLike"] = new DictionaryElement("You May Also Like These")
			.AddCultureText(this.langES, "También te Podría Gustar Esto");
		this.cultureDictionary["Feature_Recommendations_MoreTheme"] = new DictionaryElement("More From This Theme")
			.AddCultureText(this.langES, "Más de Este Tema");
		this.cultureDictionary["Feature_Recommendations_Continue"] = new DictionaryElement("Continue Shopping")
			.AddCultureText(this.langES, "Seguir Comprando");
		this.cultureDictionary["Feature_Recommendations_AlsoViewed"] = new DictionaryElement("Customers Also Viewed")
			.AddCultureText(this.langES, "Los Clientes También Vieron");
		this.cultureDictionary["Feature_Recommendations_AlsoBought"] = new DictionaryElement("Customers Also Bought")
			.AddCultureText(this.langES, "Los Clientes También Compraron");
		this.cultureDictionary["Feature_Recommendations_RecentlyViewed"] = new DictionaryElement("Recently Viewed")
			.AddCultureText(this.langES, "Visto Recientemente");
		this.cultureDictionary["Feature_Recommendations_Costumes"] = new DictionaryElement("Recommended Costumes")
			.AddCultureText(this.langES, "Disfraces Recomendados");
		this.cultureDictionary["Feature_Recommendations_For_You"] = new DictionaryElement("Recommended For You")
			.AddCultureText(this.langES, "Recomendado Para Ti");
		this.cultureDictionary["Feature_Recommendations_MysteryBoxes"] = new DictionaryElement("Mystery Boxes");
		this.cultureDictionary["Feature_Recommendations_Searched"] = new DictionaryElement("Customers Also Searched")
			.AddCultureText(this.langES, "Los Clientes También Buscaron");
		this.cultureDictionary["Feature_Recommendations_RelatedCart"] = new DictionaryElement("Related To Items In Your Cart")
			.AddCultureText(this.langES, "Relacionados Con Los Artículos De Su Carrito");
		this.cultureDictionary["Feature_Recommendations_TrendingOnFun"] = new DictionaryElement("Trending Items on FUN.com");
		this.cultureDictionary["Feature_Recommendations_PopularProducts"] = new DictionaryElement("Popular Products");
		this.cultureDictionary["Feature_Recommendations_TrendingProducts"] = new DictionaryElement("Trending Products")
			.AddCultureText(this.langES, "Productos De Tendencia");

		// Feature_Shipping
		this.cultureDictionary["Feature_Shipping_SelectState"] = new DictionaryElement("Please select your state.\n")
			.AddCultureText(this.langES, "Por favor seleccione su estado.\n");
		this.cultureDictionary["Feature_Shipping_FuturePrchseQnty"] = new DictionaryElement("Please enter a valid quantity.\n")
			.AddCultureText(this.langES, "Por favor ingrese una cantidad de compra válida.\n");
		this.cultureDictionary["Feature_Shipping_MaxQuantity"] = new DictionaryElement("We only have {0} in stock. Please select a lower quantity.")
			.AddCultureText(this.langES, "Solo tenemos {0} en stock. Por favor seleccione una cantidad menor.");
		this.cultureDictionary["Feature_Shipping_OutofStock"] = new DictionaryElement("Please select an out-of-stock item to be notified about.\n")
			.AddCultureText(this.langES, "Por favor seleccione un artículo sin stock para ser notificado.\n");
		this.cultureDictionary["Feature_Shipping_ValidEmail"] = new DictionaryElement("Please enter a valid email address.\n")
			.AddCultureText(this.langES, "Por favor, introduce una dirección de correo electrónico válida.\n");

		// Feature_Tracking
		this.cultureDictionary["Feature_Tracking_TrackOrder"] = new DictionaryElement("Track your order")
			.AddCultureText(this.langES, "Rastrea tu pedido");

		this.cultureDictionary["Feature_Global_ValidSearch"] = new DictionaryElement("Please enter something to search for.")
			.AddCultureText(this.langES, "Por favor ingrese algo para buscar.");

		// Feature_TransitBanner
		this.cultureDictionary["Feature_TransitBanner_Headline_FathersDay"] = new DictionaryElement(`There's Still Time Before <strong>Father's Day</strong> – <br class="d-lg-none" /> View Shipping Options!`)
			.AddCultureText(this.langES, `Todavía Hay Tiempo Antes De <strong>Día Del Padre</strong> – <br class="d-lg-none" /> ¡Ver Opciones De Envío!`);
		this.cultureDictionary["Feature_TransitBanner_Headline_Christmas"] = new DictionaryElement(`There's Still Time Before <strong>Christmas</strong> – <br class="d-lg-none" /> View Shipping Options!`)
			.AddCultureText(this.langES, `Todavía Hay Tiempo Antes De <strong>Navidad</strong> – <br class="d-lg-none" /> ¡Ver Opciones De Envío!`);
		this.cultureDictionary["Feature_TransitBanner_Headline_Halloween"] = new DictionaryElement(`There's Still Time Before <strong>Halloween</strong> – <br class="d-lg-none" /> View Shipping Options!`)
			.AddCultureText(this.langES, `Todavía Hay Tiempo Antes De <strong>Halloween</strong> – <br class="d-lg-none" /> ¡Ver Opciones De Envío!`);

		// Feature_Utility
		this.cultureDictionary["Feature_Uitility_ErrorMsg"] = new DictionaryElement("An error has occurred, please try again.")
			.AddCultureText(this.langES, "Ha ocurrido un error. Por favor intente otra vez.");
		this.cultureDictionary["Utility_Alert_DateFormat"] = new DictionaryElement("The date format should be : mm/dd/yyyy")
			.AddCultureText(this.langES, "El formato de fecha debe ser : mm/dd/yyy");
		this.cultureDictionary["Utility_Alert_ValidMonth"] = new DictionaryElement("Please enter a valid month")
			.AddCultureText(this.langES, "Por favor, introduzca un mes válido");
		this.cultureDictionary["Utility_Alert_ValidDay"] = new DictionaryElement("Please enter a valid day")
			.AddCultureText(this.langES, "Por favor ingrese un día válido");
		this.cultureDictionary["Utility_Alert_ValidYear"] = new DictionaryElement("Please enter a valid 4 digit year between")
			.AddCultureText(this.langES, "Ingrese un año válido de 4 dígitos entre");
		this.cultureDictionary["Utility_Alert_ValidDate"] = new DictionaryElement("Please enter a valid date")
			.AddCultureText(this.langES, "Por favor introduzca una fecha valida");

		// Form
		this.cultureDictionary["Feature_Form_Error"] = new DictionaryElement("Please correct the following errors:")
			.AddCultureText(this.langES, "Por favor corrige los siguientes errores:");
	}

	private GetBrowserCulture(): string
	{
		const metaLanguageArray = document.getElementsByName("language");
		let metaLanguage = "";

		// getting the language metatags
		if (metaLanguageArray.length > 0)
		{
			metaLanguage = metaLanguageArray[0].getAttribute("content");
		}

		// getting language from head
		if (metaLanguage.length === 0)
		{
			metaLanguage = document.getElementsByTagName("head")[0].getAttribute("lang");
		}

		// if no language in head then use selected language cookie from smartertrack
		// This is only needed on smarter track
		// if ((metaLanguage === null || metaLanguage.length === 0) && Fun.CookieManager.GetCookie("SelectedLanguage").length > 0)
		// {
		// 	metaLanguage = Fun.CookieManager.GetCookie("SelectedLanguage");
		// }

		// if no language has been defined so far, just use english
		if (metaLanguage === null || metaLanguage.length === 0)
		{
			metaLanguage = "en";
		}

		return metaLanguage.toLowerCase(); // Makes the lang attribute capitalization agnostic
	}

	private SetCultureAndLanguage(): void
	{
		if (this.culture === null)
		{
			// need to set it here
			this.culture = { Language: "", CultureCode: "" };

			// let userCultureSetting: string = "es-MX"; // This will become the html lang="XYZ" attribute
			const userCultureSetting: string = this.GetBrowserCulture(); // Get the meta html language of site the user is on.
			if (userCultureSetting)
			{
				if (userCultureSetting.length > 0)
				{
					const cultureStringArray = userCultureSetting.split("-");
					this.culture.Language = cultureStringArray[0];
					if (cultureStringArray.length > 1)
					{
						// re-build the culture code in case the original was whack
						this.culture.CultureCode = cultureStringArray[0] + "-" + cultureStringArray[1];
					}
				}
			}
		}
	}

	public ConstructSentence(key: string, item: string): string
	{
		/*
		 * item: string refers to the index of the sentence you need
		 * @string return
		 * We made this function so that it would reduce the number of lines in the dictionary and reduce confusion. To
		 * construct a sentence simply add |*| (bar star bar) to each break point. This way you can also have different
		 * sentence/word orders depending on the language needs.
		 * */
		const txt: string = this.GetTextByCulture(key);
		const splitText = txt.split("|*|");
		return splitText[item];
	}

	public FormatText(key: string, arr: string[]): string
	{
		let txt = this.GetTextByCulture(key); // same function that we used for getting the text
		for (let index = 0; index < arr.length; index++)
		{
			const arrElement = arr[index];
			const replaceText = '{' + index + '}';

			// loop until we have replaced all the text
			while (txt.indexOf(replaceText) >= 0)
			{
				txt = txt.replace(replaceText, arrElement);
			}
		}
		return txt;
	}

	public GetCulture(): string
	{
		this.SetCultureAndLanguage();
		return this.culture.CultureCode;
	}

	public GetLanguage(): string
	{
		this.SetCultureAndLanguage();
		return this.culture.Language;
	}

	public GetTextByCulture(key: string): string
	{
		let text = "";
		if (key !== null && key.length > 0)
		{
			// the key is usable
			text = null;
			if (this.cultureDictionary && this.cultureDictionary[key] !== null)
			{
				const keyElement: DictionaryElement = this.cultureDictionary[key];

				// cultures exist, try to find a match
				text = keyElement.GetCultureText(this.GetLanguage(), this.GetCulture());
			}

			text = text === null ? "" : text;
		}

		if (text.length === 0)
		{
			console.log("We need to do better than this");
		}

		return text;
	}
}

export const TextResource = new TextResourceClass();